import {
  Component,
  Inject,
  OnInit,
  AfterViewInit,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { AddReminderModalComponent } from '../../shared/reminders/components/add-reminder-modal/add-reminder-modal.component';
import { ComposeEmailComponent } from '../../email/compose-email/compose-email.component';
import { BackendApiService } from '../../../services/backend-api.service';
import { ToasterService } from '../../../services/core/toaster.service';
import { NgDialogAnimationService } from 'src/app/services/core/ng-dialog-animation.service';
import { DialogService } from '../../../services/core/dialog.service';
import { AddTaskComponent } from '../../sale/task/add-task/add-task.component';
import { ConfirmationPopupComponent } from '../../shared/confirmation-popup/confirmation-popup.component';
import { ObserverParticipantPopupComponent } from '../../sale/task/add-task/add-checklist/observer-participant-popup/observer-participant-popup.component';
import { AddEditTicketComponent } from '../add-edit-ticket/add-edit-ticket.component';
import { TicketUserPopupComponent } from '../add-edit-ticket/ticket-user-popup/ticket-user-popup.component';
import { TicketTagSelectorPopupComponent } from '../add-edit-ticket/ticket-tag-selector-popup/ticket-tag-selector-popup.component';
import { TicketSidebarComponent } from '../add-edit-ticket/ticket-sidebar/ticket-sidebar.component';
import { ExportPdfSharedComponent } from '../../shared/export-pdf/export-pdf.component';
import { TicketCommunicationService } from '../ticket-communication.service';
import { getBackgroundColor } from 'src/app/utils/utils.function';
import { environment } from 'src/environments/environment';
import { HelperService } from 'src/app/services/helper.service';
import { JsonService } from 'src/app/services/core/json.service';
import { DocumentService } from 'src/app/modules/document/document.service';
import { TICKET_MODULE_ID } from '../ticket.constants';
import { TicketDataService } from '../ticket.data.service';
import { formatDate } from '@angular/common';
import { ScopeDataService } from '../../setting/scope/scope.data.service';
import { forkJoin, Observable } from 'rxjs';
import { ProposalUnlockComponent } from '../../sale/proposal/edit-proposal/proposal-unlock/proposal-unlock.component';
import { CopyTicketDialogComponent } from '../copy-ticket-dialog/copy-ticket-dialog.component';
import { MODULE_IDS } from 'src/app/constants/module-ids.constant';

@Component({
    selector: 'app-view-ticket-detail',
    templateUrl: './view-ticket-detail.component.html',
    styleUrls: ['./view-ticket-detail.component.scss'],
    standalone: false
})
export class ViewTicketDetailComponent implements OnInit, AfterViewInit {
  // ViewChild reference to sidebar for refreshing system tags
  @ViewChild(TicketSidebarComponent, { static: false })
  ticketSidebar!: TicketSidebarComponent;

  public ticketID: any;
  model: any = '';
  /** True until the ticket has been fetched, so the panel shows a loader instead of empty placeholders. */
  isLoading = true;
  public TICKET_MODULE_ID = TICKET_MODULE_ID; // ✅ Fixed: Import from constants (was hardcoded as 7, now correctly 8)
  statuses: any = [];

  // Person type constants
  public CONST_RESPONSIBLE_PERSON_TYPE: string = 'responsible_person';
  public CONST_CREATED_BY_TYPE: string = 'created_by';
  public CONST_OBSERVER_TYPE: string = 'observer';
  public CONST_PARTICIPANT_TYPE: string = 'participant';
  TYPE_USER: any = 'Users';
  TYPE_VENDORS: any = 'Vendors';
  TYPE_CUSTOMERS: any = 'Customers';
  TYPE_SUBCONTRACTORS: any = 'Subcontractors';

  // UI state flags
  loadListingOnClose = false;
  public is_activity_log: any = 1;
  isSidebarCollapsed = false;
  isFullscreen = false;
  isSearchOpen = false;
  searchQuery = '';
  activeTabIndex = 0;
  activeTabKey = '';

  /** modules.id for Job — Materials & Services only applies to job tickets. */
  private readonly JOB_MODULE_ID = 19;
  isFavorite = false;
  isBillable = false;
  isLocked = false;

  // Permissions
  createPermission = 'DONOTAPPLY';
  editPermission = 'DONOTAPPLY';
  deletePermission = 'DONOTAPPLY';
  changeStatusPermission = 'DONOTAPPLY';
  changePriorityPermission = 'DONOTAPPLY';
  exportPDFPermission = 'DONOTAPPLY';

  // Data arrays for modern UI
  ticketTags: Array<{ id: number; name: string; color: string }> = [];
  milestones: any[] = [];
  ticketComments: any[] = [];
  ticketHistory: any[] = [];
  completionPercentage: number = 0;

  // Selected entity objects for sidebar display (matches task pattern)
  selectedCustomer: any = null;
  selectedVendor: any = null;
  selectedSubcontractor: any = null;
  selectedContact: any = null;
  selectedResponsibleParty: any = null;

  // Dropdown data for sidebar
  ticketTypesList: any = [];
  scopes: any = [];

  // Reactive form for sidebar data binding
  public sectionForm: UntypedFormGroup = new UntypedFormGroup({
    description: new UntypedFormControl(''),
    status: new UntypedFormControl(null),
    priority: new UntypedFormControl(1),
    due_date: new UntypedFormControl(null),
    start_date: new UntypedFormControl(null),
    date_finished: new UntypedFormControl(null),
    duration: new UntypedFormControl(null),
    is_time_planning: new UntypedFormControl(false),
    milestone_id: new UntypedFormControl(null),
    // Ticket-specific fields for sidebar display
    ticket_type_id: new UntypedFormControl(null),
    scopes: new UntypedFormControl(null),
    reference_id: new UntypedFormControl(null),
    customer: new UntypedFormControl(null),
    vendor: new UntypedFormControl(null),
    subcontractor: new UntypedFormControl(null),
    contact: new UntypedFormControl(null),
    party_id: new UntypedFormControl(null),
    // Checklist data for progress calculation
    check_list: new UntypedFormControl(null),
  });
  constructor(
    public dialogRef: MatDialogRef<ViewTicketDetailComponent>,
    public backendApiService: BackendApiService,
    public toasterService: ToasterService,
    public dialog: NgDialogAnimationService,
    private matDialog: MatDialog,
    public dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ticketCommunicationService: TicketCommunicationService,
    private helperService: HelperService,
    public jsonService: JsonService,
    private documentService: DocumentService,
    private ticketDataService: TicketDataService,
    private scopeDataService: ScopeDataService,
    private cdr: ChangeDetectorRef
  ) {
    this.ticketID = this.data?.id;
    this.setPermissions(this.data?.permissions);
    // Callers can land the popup on a specific tab (e.g. the dashboard's
    // Comments button opens straight to Comments). Defaults to Details.
    if (typeof this.data?.activeTabIndex === 'number') {
      this.activeTabIndex = this.data.activeTabIndex;
    }
  }

  ngOnInit(): void {
    this.getTicketByID(true);
    this.getTicketStatuses();
    this.getAllDropdownData();
    // this.getStagesOfModule(this.TASK_MODULE_ID);
  }

  /**
   * AfterViewInit lifecycle hook
   * Ensures ViewChild references (like ticketSidebar) are initialized
   */
  ngAfterViewInit(): void {
    // Intentionally empty (kept for lifecycle hook consistency)
  }

  getTicketByID(isInitialLoad: boolean = false) {
    if (!this.ticketID) {
      // Nothing to fetch, so don't leave the loader up.
      this.isLoading = false;
      return;
    }
    if (isInitialLoad) {
      this.isLoading = true;
    }
    const params =
      isInitialLoad || this.is_activity_log
        ? { is_activity_log: this.is_activity_log }
        : {};
    this.backendApiService
      .getApi(`ticket/${this.ticketID}`, params)
      .subscribe({
        next: (response: any) => {
        this.isLoading = false;
        this.model = response.data;

        // Initialize lock state from API response
        this.isLocked = this.model?.is_locked ? true : false;

        // Extract entity objects for sidebar display (matches task pattern)
        this.selectedCustomer = this.model?.customer || null;
        this.selectedVendor = this.model?.vendor || null;
        this.selectedSubcontractor = this.model?.subcontractor || null;
        this.selectedContact = this.model?.contact || null;
        this.selectedResponsibleParty = this.model?.party || null;

        // Extract tags from model
        this.ticketTags = this.extractTagsFromModel(this.model);

        // Set favorite state
        this.isFavorite = !!this.model?.is_favorite;

        // Set billable state
        this.isBillable = !!this.model?.is_billable;

        // Populate form for sidebar data binding
        // Note: Form controls should store IDs (not objects) for ng-select to work correctly
        this.sectionForm.patchValue({
          description: this.model?.description || '',
          status: this.model.status,
          priority: this.model.priority || 1,
          due_date: this.model.due_date
            ? formatDate(this.model.due_date, 'yyyy-MM-dd', 'en-US')
            : null,
          start_date: this.model.start_date
            ? formatDate(this.model.start_date, 'yyyy-MM-dd', 'en-US')
            : null,
          date_finished: this.model.date_finished
            ? formatDate(this.model.date_finished, 'yyyy-MM-dd', 'en-US')
            : null,
          duration: this.model.duration,
          is_time_planning: this.model.is_time_planning,
          milestone_id:
            this.model.module_data_milestone_id || this.model.milestone_id,
          // Ticket-specific fields - extract IDs for ng-select compatibility
          ticket_type_id:
            this.model.ticket_type?.id || this.model.ticket_type_id,
          scopes: this.extractScopeIds(this.model.scopes),
          reference_id: this.model.reference?.id || this.model.reference_id,
          customer: this.model.customer?.id || null,
          vendor: this.model.vendor?.id || null,
          subcontractor: this.model.subcontractor?.id || null,
          contact: this.model.contact?.id || null,
          party_id: this.model.party?.id || null,
          // Checklist data for progress calculation
          check_list: this.model?.check_list || [],
        });

        // Calculate progress
        this.completionPercentage = this.calculateCompletionPercentage();

        // Trigger change detection for OnPush sidebar component
        // This ensures sidebar getters (completedCount, totalCount) re-evaluate
        // and progress bar updates with correct colors on ticket reopen
        this.cdr.markForCheck();

        // Load milestones if module and reference IDs are available
        if (this.model?.module?.id && this.model?.reference?.id) {
          this.loadMilestones();
        }

        // this.getStagesOfModule(this.model?.module?.id);
        },
        // Never leave the loader up if the ticket could not be fetched.
        error: () => {
          this.isLoading = false;
          this.cdr.markForCheck();
        },
      });
    this.is_activity_log = 0;
  }

  /**
   * Load all dropdown data for sidebar
   */
  getAllDropdownData() {
    console.log('=== STARTING DROPDOWN DATA LOAD ===');
    this.scopesList();
    this.ticketTypes();
  }

  /**
   * Load ticket types from API
   */
  ticketTypes() {
    console.log('=== LOADING TICKET TYPES ===');
    this.backendApiService.getApi('ticket-types', {}, false).subscribe(
      (response: any) => {
        console.log('Ticket Types API Response:', response);
        this.ticketTypesList = response; // Match add-edit-ticket implementation
        console.log('Ticket Types Loaded:', this.ticketTypesList);
        this.cdr.markForCheck(); // Trigger OnPush change detection
      },
      (error: any) => {
        console.error('Error loading ticket types:', error);
        this.ticketTypesList = [];
        this.cdr.markForCheck(); // Trigger OnPush change detection
      }
    );
  }

  /**
   * Load scopes from API
   */
  scopesList() {
    console.log('=== LOADING SCOPES ===');
    // On a Job ticket the sidebar lists that job's scopes — the same source the
    // Materials picker uses. Other modules keep the office-wide catalogue.
    // Either way the stored value is the MASTER scope id, so the scope_ticket
    // pivot means the same thing on every module.
    if (this.showMaterialsTab) {
      const jobId = this.model?.job_id || this.model?.reference?.id;

      this.ticketDataService.getJobScopes(jobId).subscribe({
        next: (response: any) => {
          const rows = response?.data?.data ?? response?.data ?? [];
          const seen = new Set<number>();

          this.scopes = (Array.isArray(rows) ? rows : [])
            .filter((row: any) => {
              if (!row?.scope_id || seen.has(row.scope_id)) {
                return false;
              }
              seen.add(row.scope_id);
              return true;
            })
            .map((row: any) => ({ id: row.scope_id, name: row.scope_name }));

          this.cdr.markForCheck();
        },
        error: () => {
          this.scopes = [];
          this.cdr.markForCheck();
        },
      });
      return;
    }

    this.scopeDataService.userSelectedScopesList().subscribe(
      (response: any) => {
        this.scopes = response.data;
        this.cdr.markForCheck(); // Trigger OnPush change detection
      },
      (error: any) => {
        console.error('Error loading scopes:', error);
        this.scopes = [];
        this.cdr.markForCheck(); // Trigger OnPush change detection
      }
    );
  }

  editTask() {
    if (this.isLocked) {
      return;
    }
    this.close();
    this.dialogService.onOpenFromRightDialog(
      AddEditTicketComponent,
      {
        isEdit: true,
        model: this.model,
        id: this.model?.id,
      },
      1300
    );
    this.dialogService.afterClose()?.subscribe((result: any) => {
      if (result) {
        this.ticketCommunicationService.setTicketListUpdate(true);
      }
    });
  }

  onConfirmation(): void {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      width: '500px',
      height: '300px',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.onDelete();
      }
    });
  }

  onDelete() {
    if (this.isLocked) {
      return;
    }
    this.backendApiService
      .deleteApi(`ticket/${this.model?.id}`)
      .subscribe((response: any) => {
        this.toasterService.showSuccessMessage(response.data.message);
        this.close(true);
      });
  }

  close = (data: any = null) => {
    this.dialogRef.close(data);
  };

  createTicket() {
    this.close();
    this.dialogService.onOpenFromRightDialog(
      AddEditTicketComponent,
      {
        moduleID: this.model?.module?.id,
        referenceID: this.model?.reference?.id,
      },
      1300
    );
    this.dialogService.afterClose()?.subscribe((result: any) => {
      if (result) {
      }
    });
  }

  openCopyTicketDialog(): void {
    if (this.isLocked) {
      return;
    }

    const dialogRef = this.dialog.open(CopyTicketDialogComponent, {
      width: '520px',
      maxHeight: '90vh',
      panelClass: 'copy-ticket-dialog-container',
      data: {
        ticketId: this.ticketID ?? this.model?.id,
        ticketTitle: this.model?.name,
        moduleId: this.model?.module?.id ?? this.model?.module_id,
        referenceId: this.model?.reference?.id ?? this.model?.reference_id,
        referenceName:
          this.model?.reference?.name ||
          this.model?.reference?.reference_number ||
          this.model?.reference?.ref_number ||
          this.model?.reference?.bid_number ||
          this.model?.reference?.job_number ||
          this.model?.reference?.proposal_number ||
          this.model?.reference?.code,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.copied) {
        this.loadListingOnClose = true;
        const newId = result?.newId;
        if (newId) {
          this.ticketID = newId;
          this.getTicketByID(true);
        } else {
          this.getTicketByID(false);
        }
        this.ticketCommunicationService.setTicketListUpdate(true);
      }
    });
  }

  openUserPopup(event: any, type: any) {
    const position = event.target.getBoundingClientRect();
    const dialogRef = this.dialog.open(TicketUserPopupComponent, {
      width: '400px',
      height: '400px',
      // position: {top:`${position.top+ 30}px`, left: `${position.left - 360}px`},
      data: {
        type: type,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      console.log('result', result);
      if (result) {
        if (result.type == this.CONST_RESPONSIBLE_PERSON_TYPE) {
          this.addResponsiblePerson({
            user: result?.user,
            type: result?.selectedTab,
          });
        } else if (result.type == this.CONST_OBSERVER_TYPE) {
          this.addObserver({ user: result?.user, type: result?.selectedTab });
        } else if (result.type == this.CONST_PARTICIPANT_TYPE) {
          this.addParticipant({
            user: result?.user,
            type: result?.selectedTab,
          });
        }
      }
    });
  }

  addResponsiblePerson(user: any) {
    const users = [];
    users.push(user?.user.id);
    const usersList = this.model?.responsible_persons;
    const alreadyExistCheck = usersList.find((x: any) => x.id == user?.user.id);
    if (!alreadyExistCheck) {
      this.backendApiService
        .postApi('ticket/add/responsible/person/' + this.model?.id, {
          user_id: users,
          type: user?.type,
        })
        .subscribe((response: any) => {
          this.toasterService.showSuccessMessage(response?.data?.message);
          this.model?.responsible_persons?.push(response?.data?.data);
        });
    }
  }

  addObserver(user: any) {
    const users = [];
    users.push(user?.user.id);
    const usersList = this.model?.observers;
    const alreadyExistCheck = usersList.find((x: any) => x.id == user?.user.id);
    if (!alreadyExistCheck) {
      this.backendApiService
        .postApi('ticket/add/observer/' + this.model?.id, {
          user_id: users,
          type: user?.type,
        })
        .subscribe((response: any) => {
          this.toasterService.showSuccessMessage(response?.data?.message);
          this.model?.observers?.push(response?.data?.data);
        });
    }
  }

  addParticipant(user: any) {
    const users = [];
    users.push(user?.user.id);
    const usersList = this.model?.participants;
    const alreadyExistCheck = usersList.find((x: any) => x.id == user?.user.id);
    if (!alreadyExistCheck) {
      this.backendApiService
        .postApi('ticket/add/participant/' + this.model?.id, {
          user_id: users,
          type: user?.type,
        })
        .subscribe((response: any) => {
          this.toasterService.showSuccessMessage(response?.data?.message);
          this.model?.participants?.push(response?.data?.data);
        });
    }
  }

  deleteAssociation(user: any) {
    this.backendApiService
      .deleteApi('ticket/association/' + user?.assoc_id)
      .subscribe((response: any) => {
        this.toasterService.showSuccessMessage(response.data?.message);
        this.getTicketByID(false);
      });
  }

  getChipIconUsingType(type: any) {
    let image = '';
    switch (type) {
      case this.TYPE_USER:
        image = '../../../../assets/img/general_icons/user-dark.png';
        break;
      case this.TYPE_CUSTOMERS:
        image = '../../../../assets/img/general_icons/custo-dark.png';
        break;
      case this.TYPE_VENDORS:
        image = '../../../../assets/img/general_icons/vendor-dark.png';
        break;
      case this.TYPE_SUBCONTRACTORS:
        image = '../../../../assets/img/general_icons/subcon-dark.png';
        break;
      default:
        image = '../../../../assets/img/general_icons/admin-dark.png';
    }
    return image;
  }

  generatePDF() {
    const dialogRef = this.dialog.open(ExportPdfSharedComponent, {
      width: '30%',
      // height: '80%',
      data: {
        moduleName: 'ticket',
        moduleSlug: 'ticket',
        recordId: this.model.id,
        moduleId: this.TICKET_MODULE_ID,
        // Email support: reuse the existing preview URL + ticket context.
        generatePdfUrl: environment.apiBaseUrl + '/ticket/generate-pdf',
        recordModuleName: 'Ticket',
        referenceName: this.model?.ticket_code || this.ticketID,
        emailSubject: `Ticket #${this.model?.ticket_code || this.ticketID}`
          + (this.model?.name ? ` - ${this.model.name}` : ''),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Dead code: `type: 3` can no longer be produced by the Export PDF dialog's
        // "Save to Documents" button (it now saves internally via a document-picker
        // flow and closes with {success:true}/void instead). Commented out instead
        // of deleted pending a full audit of this pattern across the app.
        // if (result.type == 3) {
        //   const userDetail = this.jsonService.doParse(
        //     localStorage.getItem('auth_detail')
        //   );
        //   Object.values(result?.templates)?.map((templateValue: any) => {
        //     const url = `${environment.apiBaseUrl}/save-document?id=${this.model.id}&template_id=${templateValue}&output=2&user_id=${userDetail?.id}&module_id=${this.TICKET_MODULE_ID}`;
        //     this.documentService.saveDocuments(url).subscribe(
        //       (res: any) => { },
        //       (error) => {
        //         this.toasterService.showError(
        //           'Error',
        //           'Internal Server Error!'
        //         );
        //       }
        //     );
        //   });
        // } else {
        // Email is handled inside the modal ({emailed:true}); only Preview/Download
        // go through getTemplates.
        if (result.type === 1 || result.type === 2) {
          this.helperService.getTemplates(
            environment.apiBaseUrl + '/ticket/generate-pdf',
            this.model.id,
            result
          );
        }
        // }

        // this.toasterService.showWarning('PDF export not available.');
      }
    });
  }
  getTicketStatuses() {
    this.backendApiService
      .getApi('statuses/ticket')
      .subscribe((response: any) => {
        this.statuses = response?.data;
      });
  }
  onChangeStatus(data: any) {
    this.backendApiService
      .postApi('ticket/change-status/' + this.model?.id, { status: data?.id })
      .subscribe((response: any) => {
        this.toasterService.showSuccessMessage(response?.data.message);
        this.getTicketByID(false);
        this.ticketCommunicationService.setTicketListUpdate(true);
      });
  }

  /**
   * Update ticket priority in view mode
   * Calls API to update priority and refreshes ticket data
   */
  onPriorityChange(priority: any): void {
    this.backendApiService
      .postApi(`ticket/update-priority/${this.ticketID}`, {
        priority: priority.id,
      })
      .subscribe(
        (response: any) => {
          this.toasterService.showSuccessMessage(
            response?.message || 'Priority updated successfully'
          );
          this.model.priority = priority.id;
          this.getTicketByID(false); // Refresh to get updated data
          this.ticketCommunicationService.setTicketListUpdate(true);
        },
        (error: any) => {
          this.toasterService.showError('Failed to update priority');
          console.error('Priority update error:', error);
        }
      );
  }

  /**
   * Open tag selector popup for creating new tags
   * Opens dialog and creates tag via API on confirmation
   */
  openTagSelector(): void {
    const dialogRef = this.matDialog.open(TicketTagSelectorPopupComponent, {
      width: '480px',
      maxWidth: '480px',
      maxHeight: '80vh',
      panelClass: 'ticket-tag-selector-popup-dialog-container',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.name && result.color) {
        // Color hex mapping
        const colorHexMap: { [key: string]: string } = {
          blue: '#3b82f6',
          green: '#22c55e',
          yellow: '#eab308',
          red: '#ef4444',
          purple: '#a855f7',
          orange: '#f97316',
          gray: '#6b7280',
          pink: '#ec4899',
          indigo: '#6366f1',
          teal: '#14b8a6',
        };

        const payload = {
          module_id: this.TICKET_MODULE_ID, // 8 for tickets
          reference_id: 0, // 0 for system tags
          tag: result.name.trim(),
          color:
            colorHexMap[result.color?.toLowerCase()] ||
            result.color ||
            '#6b7280',
          is_system: 1,
        };

        this.ticketDataService.createTag(payload).subscribe({
          next: (response: any) => {
            console.log('System tag created:', response);
            if (response?.data?.id) {
              // Apply tag to current ticket (attach it)
              const attachPayload = new FormData();
              attachPayload.append('module_id', '8'); // Ticket module ID
              attachPayload.append('reference_id', String(this.ticketID)); // Current ticket
              attachPayload.append('tag', result.name.trim());
              attachPayload.append(
                'color',
                colorHexMap[result.color?.toLowerCase()] ||
                result.color ||
                '#6b7280'
              );
              attachPayload.append('is_system', '0'); // Reference-specific (applied to ticket)

              this.backendApiService
                .postApi('user/tags', attachPayload)
                .subscribe({
                  next: (attachResponse: any) => {
                    console.log('Tag applied to ticket:', attachResponse);

                    // Create tag object using the APPLIED tag's ID (not system tag ID)
                    const appliedTag = {
                      id: attachResponse?.data?.id || response.data.id, // Use applied tag ID
                      name: result.name,
                      color: result.color,
                    };

                    // Add to local tags array
                    this.ticketTags.push(appliedTag);
                    console.log('Tag added to ticketTags array:', appliedTag);

                    // Refresh sidebar system tags dropdown
                    console.log(
                      'Attempting to refresh sidebar tags. ticketSidebar exists:',
                      !!this.ticketSidebar
                    );
                    if (this.ticketSidebar) {
                      this.ticketSidebar.refreshSystemTags();
                      console.log('Sidebar tags refreshed successfully');
                    } else {
                      console.warn(
                        'ticketSidebar ViewChild is undefined - cannot refresh dropdown'
                      );
                    }

                    this.toasterService.showSuccessMessage(
                      'Tag created and applied successfully'
                    );

                    // Trigger change detection for OnPush strategy
                    this.cdr.markForCheck();

                    // Refresh ticket data to sync with backend
                    this.getTicketByID(false);
                  },
                  error: (attachError: any) => {
                    console.error(
                      'Failed to apply tag to ticket:',
                      attachError
                    );
                    this.toasterService.showError(
                      'Tag created but failed to apply to ticket'
                    );
                  },
                });
            }
          },
          error: (error: any) => {
            console.error('Failed to create tag:', error);
            this.toasterService.showError(
              'Failed to create tag. Please try again.'
            );
          },
        });
      }
    });
  }

  /**
   * Update ticket tags in view mode
   * Uses unified user/tags endpoint (same as Task module)
   * Makes individual API calls for added/removed tags
   */
  onTagsUpdated(tags: any[]): void {
    if (!this.ticketID) {
      this.toasterService.showError('Ticket ID not found');
      return;
    }

    // Find tags to add (in new tags but not in current ticketTags)
    const tagsToAdd = tags.filter(
      (newTag) =>
        !this.ticketTags.some(
          (oldTag) => oldTag.name === newTag.name || oldTag.id === newTag.id
        )
    );

    // Find tags to remove (in current ticketTags but not in new tags)
    const tagsToRemove = this.ticketTags.filter(
      (oldTag) =>
        !tags.some(
          (newTag) => newTag.name === oldTag.name || newTag.id === oldTag.id
        )
    );

    const apiCalls: Observable<any>[] = [];

    // Add new tags using unified user/tags endpoint
    tagsToAdd.forEach((tag) => {
      const payload = new FormData();
      payload.append('module_id', '8'); // Ticket module ID
      payload.append('reference_id', String(this.ticketID));
      payload.append('tag', tag.name || tag.tag);
      payload.append('color', tag.color || '#6b7280');
      payload.append('is_system', '0');

      apiCalls.push(this.backendApiService.postApi('user/tags', payload));
    });

    // Remove old tags
    tagsToRemove.forEach((tag) => {
      if (tag.id) {
        apiCalls.push(this.backendApiService.deleteApi(`user/tags/${tag.id}`));
      }
    });

    // Execute all API calls
    if (apiCalls.length > 0) {
      forkJoin(apiCalls).subscribe(
        () => {
          this.toasterService.showSuccessMessage('Tags updated successfully');
          this.ticketTags = tags;
          this.getTicketByID(false);
          this.ticketCommunicationService.setTicketListUpdate(true);
        },
        (error) => {
          this.toasterService.showError('Failed to update tags');
          console.error('Tags update error:', error);
          this.getTicketByID(false);
        }
      );
    } else {
      // No changes, just update local state
      this.ticketTags = tags;
    }
  }

  /**
   * Mark ticket as complete
   * Updates ticket status to completed via API and refreshes view
   */
  markAsComplete() {
    this.backendApiService
      .patchApi(`ticket/mark-completed/${this.model?.id}`, {})
      .subscribe(
        (response: any) => {
          this.toasterService.showSuccessMessage(
            response?.data?.message || 'Ticket marked as completed'
          );
          this.loadListingOnClose = true;
          this.getTicketByID(false);
        },
        (error: any) => {
          this.toasterService.showError(
            error?.error?.message || 'Failed to mark ticket as completed'
          );
        }
      );
  }

  getBackgroundColor(color: string) {
    return getBackgroundColor(color);
  }
  setPermissions(permissions: any) {
    if (permissions) {
      if (permissions?.isLocked !== undefined) {
        this.isLocked = permissions?.isLocked;
      }
      if (permissions?.createPermission) {
        this.createPermission = permissions?.createPermission;
      }
      if (permissions?.editPermission) {
        this.editPermission = permissions?.editPermission;
      }

      if (permissions?.deletePermission) {
        this.deletePermission = permissions?.deletePermission;
      }
      if (permissions?.changeStatusPermission) {
        this.changeStatusPermission = permissions?.changeStatusPermission;
      }
      if (permissions?.changePriorityPermission) {
        this.changePriorityPermission = permissions?.changePriorityPermission;
      }
      if (permissions?.exportPDFPermission) {
        this.exportPDFPermission = permissions?.exportPDFPermission;
      }
    }
  }

  /**
   * Toggle lock/unlock status
   */
  toggleLock(): void {
    const dialogRefLock = this.dialog.open(ProposalUnlockComponent, {
      width: '500px',
      maxHeight: '80vh',
      panelClass: 'lock-dialog-container',
      data: {
        title: 'Ticket',
        model: this.model,
        is_locked: this.isLocked ? 0 : 1,
        url: `ticket/${this.model?.id}/toggle-unlock`,
      },
    });
    dialogRefLock.afterClosed().subscribe((result) => {
      if (result) {
        this.isLocked = !this.isLocked;
        this.model.is_locked = this.isLocked ? 1 : 0;
      }
    });
  }

  /**
   * Load milestones for the current module and reference
   * Transforms API response to UI-ready format with calculated fields
   */
  loadMilestones() {
    if (!this.model?.reference?.id) {
      this.milestones = [];
      return;
    }

    this.ticketDataService
      .getMilestones(this.TICKET_MODULE_ID, this.model.reference.id)
      .subscribe(
        (response: any) => {
          if (response?.data && Array.isArray(response.data)) {
            // Transform each milestone using transformMilestoneData()
            this.milestones = response.data.map((m: any) =>
              this.transformMilestoneData(m)
            );
          } else {
            this.milestones = [];
          }
        },
        (error) => {
          console.error('Error loading milestones:', error);
          this.milestones = [];
        }
      );
  }

  /**
   * Transform API milestone data to match ticket milestone interface
   */
  private transformMilestoneData(apiMilestone: any): any {
    const tasks = apiMilestone.tasks || [];

    const completedTasks = tasks.filter(
      (task: any) =>
        task.status === 'completed' ||
        task.status_name?.toLowerCase() === 'completed' ||
        task.completed_at !== null
    );

    let status = apiMilestone.status;

    if (
      !status ||
      !['upcoming', 'in-progress', 'completed', 'overdue'].includes(status)
    ) {
      if (apiMilestone.completed_at) {
        status = 'completed';
      } else if (
        apiMilestone.due_date &&
        new Date(apiMilestone.due_date) < new Date()
      ) {
        status = 'overdue';
      } else if (apiMilestone.progress > 0 || completedTasks.length > 0) {
        status = 'in-progress';
      } else {
        status = 'upcoming';
      }
    }

    let progress = apiMilestone.progress;

    if (progress === undefined && tasks.length > 0) {
      progress = Math.round((completedTasks.length / tasks.length) * 100);
    } else if (progress === undefined) {
      progress = 0;
    }

    let daysRemaining = apiMilestone.days_left;

    if (daysRemaining === undefined && apiMilestone.due_date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const dueDate = new Date(apiMilestone.due_date);
      dueDate.setHours(0, 0, 0, 0);

      const diffTime = dueDate.getTime() - today.getTime();
      daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }

    const transformed = {
      id: apiMilestone.id,
      name:
        apiMilestone.milestone_name || apiMilestone.name || 'Unnamed Milestone',
      dueDate: apiMilestone.due_date || apiMilestone.dueDate,
      startDate: apiMilestone.start_date || apiMilestone.startDate,
      endDate: apiMilestone.end_date || apiMilestone.endDate,
      status: status,
      progress: progress,
      daysRemaining: daysRemaining,
      taskStats:
        tasks.length > 0
          ? {
            total: tasks.length,
            completed: completedTasks.length,
          }
          : undefined,
      description: apiMilestone.description,
      assignedTo: apiMilestone.assigned_to_name || apiMilestone.assignedTo,
    };

    return transformed;
  }

  /**
   * Calculate ticket progress based on status and checklist completion
   */
  private calculateCompletionPercentage(): number {
    // Check if ticket is marked as complete via status
    const status = this.model?.status_label?.name || '';
    if (this.isTicketComplete(status)) {
      return 100;
    }

    // Calculate based on checklist completion
    const checklist = this.model?.check_list || [];

    if (!Array.isArray(checklist) || checklist.length === 0) {
      return 0;
    }

    const completed = checklist.filter((item: any) =>
      this.isChecklistItemCompleted(item)
    ).length;

    return Math.round((completed / checklist.length) * 100);
  }

  /**
   * Check if a status indicates ticket completion
   */
  private isTicketComplete(status: string): boolean {
    if (!status) return false;

    const statusName = status.toLowerCase().trim();

    const completionKeywords = [
      'complete',
      'completed',
      'done',
      'finished',
      'closed',
      'resolved',
      'solved',
    ];

    return completionKeywords.some((keyword) => statusName.includes(keyword));
  }

  private isChecklistItemCompleted(item: any): boolean {
    const value =
      item?.is_completed ?? item?.completed ?? item?.status ?? false;

    if (typeof value === 'string') {
      return value === '1' || value.toLowerCase() === 'true';
    }

    return value === true || value === 1;
  }

  /**
   * Toggle favorite status for ticket
   */
  toggleFavorite(): void {
    if (this.isLocked) {
      return;
    }
    const previous = this.isFavorite;
    this.isFavorite = !this.isFavorite; // optimistic UI

    const payload = {
      reference_id: this.model?.id,
      module_id: this.TICKET_MODULE_ID, // 8 for tickets
      is_favorite: this.isFavorite ? 1 : 0,
    };

    this.backendApiService.postApi('user/favorites/mark', payload).subscribe(
      (response: any) => {
        this.toasterService.showSuccessMessage(
          this.isFavorite
            ? 'Ticket added to favorites'
            : 'Ticket removed from favorites'
        );
        if (this.model) {
          this.model.is_favorite = this.isFavorite ? 1 : 0;
        }
      },
      (error: any) => {
        // revert on error
        this.isFavorite = previous;
        this.toasterService.showError('Failed to update favorite state');
      }
    );
  }

  /**
   * Extract scope IDs from scopes array
   * Handles both array of objects [{id: 1, name: "..."}] and array of IDs [1, 2, 3]
   * @param scopes Scopes from API (could be objects or IDs)
   * @returns Array of scope IDs for ng-select
   */
  extractScopeIds(scopes: any): number[] {
    if (!scopes || !Array.isArray(scopes)) {
      return [];
    }

    // If scopes is array of objects, extract IDs
    if (
      scopes.length > 0 &&
      typeof scopes[0] === 'object' &&
      scopes[0] !== null
    ) {
      return scopes
        .map((scope: any) => scope.id)
        .filter((id: any) => id != null);
    }

    // If scopes is already array of IDs, return as-is
    return scopes.filter((id: any) => typeof id === 'number');
  }

  /**
   * Extract tags from ticket model
   * Checks multiple possible tag locations in API response
   */
  extractTagsFromModel(model: any): Array<{
    id: number;
    name: string;
    color: string;
    created_at?: string;
    updated_at?: string;
  }> {
    // Debug logging to identify actual API structure
    if (model) {
      console.log('Tag extraction - model.relations:', model.relations);
      console.log('Tag extraction - model.tags:', model.tags);
      console.log('Tag extraction - model.tag_ids:', model.tag_ids);
    }

    // Try multiple possible locations for tags
    let tagsArray: any[] = [];

    if (model?.relations?.tags && Array.isArray(model.relations.tags)) {
      tagsArray = model.relations.tags;
    } else if (model?.tags && Array.isArray(model.tags)) {
      tagsArray = model.tags;
    } else if (model?.tag_data && Array.isArray(model.tag_data)) {
      tagsArray = model.tag_data;
    }

    if (tagsArray.length === 0) {
      console.log('No tags found in any location');
      return [];
    }

    // Map tags and include timestamp fields
    const mappedTags = tagsArray.map((tag: any) => ({
      id: tag.id || tag.tag_id,
      name: tag.name || tag.tag_name || tag.tag || '',
      color: tag.color || tag.tag_color || '#6b7280',
      created_at: tag.created_at,
      updated_at: tag.updated_at,
    }));

    // Sort by created_at descending (last applied tag first)
    return mappedTags.sort((a, b) => {
      if (!a.created_at || !b.created_at) return 0;
      return (
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
      );
    });
  }

  /**
   * Handle tab change event
   */
  /**
   * Materials & Services applies only to tickets on a Job — other modules have
   * no scope items to draw from, so the tab is hidden entirely.
   */
  get showMaterialsTab(): boolean {
    const isJobModule = this.model?.module?.id === this.JOB_MODULE_ID
      || (this.model?.reference_type || '').endsWith('Job');

    return isJobModule && !!(this.model?.job_id || this.model?.reference?.id);
  }

  /** Which tab is open, by stable key — indices shift as tabs are hidden. */
  handleTabKeyChange(tabKey: string): void {
    this.activeTabKey = tabKey;
  }

  handleTabChange(index: number): void {
    this.activeTabIndex = index;
  }

  /**
   * Handle checklist change and recalculate progress
   */
  handleChecklistChange(checklists: any): void {
    if (this.model) {
      this.model.check_list = checklists;
      // Update form control for sidebar access
      this.sectionForm.patchValue({
        check_list: checklists,
      });
      this.completionPercentage = this.calculateCompletionPercentage();
    }
  }

  /**
   * Keep the local model in sync as Materials & Services rows are added/edited so
   * the tab badge count updates without a refetch.
   *
   * This read-only dialog has no save of its own — rows entered here persist when
   * the ticket is saved from the edit dialog.
   */
  handleMaterialServicesChange(ticketItems: any): void {
    if (this.model) {
      this.model.ticket_items = ticketItems;
    }
  }

  /**
   * Handle search input
   */
  handleSearch(query: string): void {
    this.searchQuery = query;
    // TODO: Implement search functionality if needed
  }

  /**
   * Get selected milestone object
   */
  getSelectedMilestone(): any {
    const milestoneId = this.sectionForm.get('milestone_id')?.value;
    if (!milestoneId || !this.milestones || this.milestones.length === 0) {
      return null;
    }

    return this.milestones.find((m: any) => m.id === milestoneId) || null;
  }

  /**
   * Get priority text from priority number
   */
  getPriorityText(priority: number): string {
    const priorityMap: { [key: number]: string } = {
      1: 'Low',
      2: 'Medium',
      3: 'High',
      4: 'Urgent',
    };

    return priorityMap[priority] || 'Medium';
  }

  /**
   * Get project name from model
   */
  getProjectName(): string {
    return this.model?.reference?.name || '';
  }

  /**
   * Detail-page routes for module ids a ticket's linked record can point to.
   * Mirrors view-task-detail.component.ts's LINKED_RECORD_ROUTES so both
   * modules resolve the same module id the same way — extend both maps
   * together if a new module needs a route.
   */
  private readonly LINKED_RECORD_ROUTES: Partial<Record<number, (id: number | string) => string>> = {
    [MODULE_IDS.PRODUCT]: (id) => `/products/product/${id}`,
    [MODULE_IDS.STAFF]: (id) => `/hr/staff/${id}`,
    [MODULE_IDS.VENDOR]: (id) => `/vendors/vendor/${id}`,
    [MODULE_IDS.CUSTOMER]: (id) => `/customers/customer/${id}`,
    [MODULE_IDS.BID]: (id) => `/bids/bid/${id}`,
    [MODULE_IDS.WAREHOUSE]: (id) => `/warehouses/warehouse/${id}`,
    [MODULE_IDS.JOB]: (id) => `/jobs/detail/${id}`,
    [MODULE_IDS.CHANGE_ORDER]: (id) => `/change-order/edit/${id}`,
  };

  /**
   * Route to the ticket's linked module record, or null when the module id
   * is unmapped or record data is unavailable — caller falls back to plain
   * text rather than guessing a URL. No permission check: the destination
   * page re-fetches the record from the backend and enforces access itself.
   */
  getRecordRoute(): string | null {
    const moduleId = this.model?.module?.id;
    const recordId = this.model?.reference?.id;

    if (!moduleId || !recordId) {
      return null;
    }

    const buildRoute = this.LINKED_RECORD_ROUTES[moduleId];
    return buildRoute ? buildRoute(recordId) : null;
  }

  /**
   * Set reminder for ticket
   */
  setReminder(): void {
    const ticketName = this.model?.name || this.model?.title || `Ticket #${this.ticketID}`;
    const dialogData: any = {
      reminderable_type: 'App\\Models\\Ticket',
      reminderable_id: this.ticketID,
      entityName: ticketName
    };

    // Add location if present in ticket model
    if (this.model?.location) {
      dialogData.location = this.model.location;
    }

    const dialogRef = this.matDialog.open(AddReminderModalComponent, {
      panelClass: 'reminder-modal-panel',
      disableClose: false,
      autoFocus: true,
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toasterService.showSuccessMessage('Reminder set successfully!');
      }
    });
  }

  /**
   * Open email compose dialog with ticket context
   * Pre-fills recipient from ticket customer's email and subject with ticket name
   */
  composeEmail(): void {
    const dialogRef = this.matDialog.open(ComposeEmailComponent, {
      width: '700px',
      height: '600px',
      data: {
        mode: 'compose',
        linkedTicketId: this.ticketID,
        prefillTo: this.model?.customer?.primary_contact?.email || this.model?.customer?.email || '',
        prefillSubject: this.model?.name ? `RE: Ticket #${this.model?.ticket_code || this.ticketID} - ${this.model.name}` : '',
      },
      panelClass: 'compose-email-dialog-container'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toasterService.showSuccessMessage('Email sent successfully');
      }
    });
  }
}
